import { useEffect, useState } from 'react'

import { useBoundStore } from '../store/store'
import type { CasinoSlice } from '../store/types/casino'
import { api } from '../utils/api-client'

const useProviders = () => {
  const [isLoading, setIsLoading] = useState<boolean>(false)
  const providers = useBoundStore(state => state.casino.providers)
  const setProviders = useBoundStore(state => state.casino.setProviders)
  const username = useBoundStore(state => state.user.username)

  useEffect(() => {
    if (Object.keys(providers || {}).length) return

    const controller = new AbortController()
    const signal = controller.signal

    const fetchCategories = async () => {
      setIsLoading(true)

      try {
        const res = await api.get<CasinoSlice>(
          '/games/lists.php',
          {
            account: username,
          },
          { signal },
        )

        setProviders(res.data.providers)
      } catch (error) {
        console.error(error)
      } finally {
        setIsLoading(false)
      }
    }

    fetchCategories()

    return () => {
      controller.abort()
    }
  }, [providers, username])

  return {
    providers,
    isLoading,
  }
}

export default useProviders
